module.exports = __webpack_public_path__ + "assets/img/00183.5523d3cb.png";